import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-5bd05a34"), n = n(), _popScopeId(), n); };
var _hoisted_1 = {
    key: 0,
    class: "pdf-viewer-modal fixed top-0 left-0 h-full w-full bg-gray-100"
};
import { computed } from 'vue';
import EPdfViewer from '@common/ui/EPdfViewer/EPdfViewer.vue';
import { PdfViewerStore } from "@common/stores";
export default /*#__PURE__*/ _defineComponent({
    __name: 'PdfViewerModal',
    setup: function (__props) {
        var pdfViewerStore = PdfViewerStore;
        var src = computed(function () { return pdfViewerStore.src; });
        var visible = computed(function () { return !!src.value; });
        return function (_ctx, _cache) {
            return (visible.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(EPdfViewer, {
                        src: src.value,
                        class: "w-full h-full"
                    }, null, 8, ["src"])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
